module.exports = __webpack_public_path__ + "portal-static/img/customer_service.1169f1d3.png";